<template>
  <span>
    <li @click.stop="handleModalClick" class="action">
      <i class="fal fa-info-circle"></i>Details
    </li>
  </span>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import moment from "moment-timezone";
export default {
  data: function () {
    return {}
  },
  props: ["content", "rallyId", "channelId"],
  methods: {
    ...mapActions("user", ["setModalProps"]),
    handleModalClick() {
      this.setModalProps({ name: 'ContentDetailsModal', rallyId: this.rallyId, modalVariant: 'single', content: this.content, channelId: this.channelId });
    },
  }
}
</script>
